<template lang="pug">
vm-row(vm-w="12")
  vm-col.card(vm-sm=12)
    vm-table(v-model="selected"  max-height="350px" :data="commissionsCatalog.commissions")
      template(slot="header")
        .d-flex.justify-content-between
          vm-input(icon="search" size="small" :placeholder="$t('strings.search')" v-model="filters.where.param" @keyup.enter="applyFilters")
          div
          .heading.d-flex.justify-content-between
            vm-tooltip(:text="$t('strings.filters')" delay=".5s")          
              vm-dropdown(ref="dropdown" vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="default" icon="funnel-outline" size="small")
                vm-dropdown-menu(class="filters")
                  .heading.d-flex.justify-content-between
                    h4 {{ $t('strings.filters') }}
                    vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                  vm-date-picker.filter(type="daterange" :label="$t('commissions.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.created_at")
                  .filter.d-flex
                    vm-button(@click="applyFilters") {{ $t('strings.apply') }} 
            vm-select(:placeholder="$t('strings.order_by')" autocomplete v-model="filters.orderBy" @change="applyFilters" size="small" width="200px")
              div(v-for="(item,index) in columns")
                vm-select-item(:key="item + ',asc'" v-if="item !== ''" :value="item + ',asc'" :text="$t('commissions.'+ item) + ', asc'")
                vm-select-item(:key="item + ',desc'" v-if="item !== ''" :value="item + ',desc'" :text="$t('commissions.'+ item) + ', desc'")                               
      template(slot="thead")
        vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('commissions.' + column) }}
      template(slot-scope="{data}")
        vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
          vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
            slot(v-if="column !== 'created_at' && column !== 'commission_percentage' && column !== 'sale_total' && column !== 'sale_subtotal' && column !== 'exchange_rate' && column !== 'sale_total_mxn' && column !== 'sale_subtotal_mxn' && column !== 'calculated_commission'") {{ data[indextr][column] }}
            slot(v-if="column == 'sale_total' || column == 'sale_subtotal' || column == 'exchange_rate' || column == 'sale_total_mxn' || column == 'sale_subtotal_mxn' || column == 'calculated_commission'") {{ data[indextr][column] | currency}}
            slot(v-if="column == 'created_at'") {{ data[indextr][column] | moment('DD-MMMM-YYYY') }}
            .input__wrapper(v-if="column == 'commission_percentage'")
              vm-input(v-model="data[indextr].commission_percentage" :disabled="!$auth.check('Admin')" @input-change="changeInput(data[indextr])")
    vm-pagination(:total="paginationOpenCommissions.totalPages" v-model="currentPage" goto)
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('CommissionsV2')

export default {
  name: 'OpenCommissionsTab',
  data: () => ({
    currentPage: 1,
    selected: [],
    columns: [
      'created_at',
      'sale_folio',
      'quotation_folio',
      'customer_name',
      'seller_name',
      'sale_total',
      'sale_subtotal',
      'currency',
      'exchange_rate',
      'sale_total_mxn',
      'sale_subtotal_mxn',
      'commission_percentage',
      'calculated_commission'
    ],
    columnsOrderBy: [
      'created_at'
    ],
    attributeModal: 'name',
    filters: {
      where: {
        sale: {
          folio: ''
        },
        status: 1,
        param: ''
      },
      whereIn: {},
      whereBetween: {

      },
      betweenDates: {
        created_at: []
      },
      orderBy: ''
    }
  }),
  created () {
    this.applyFilters()
  },
  computed: {
    ...mapGetters(['commissionsCatalog', 'paginationOpenCommissions'])
  },
  watch: {
    currentPage (page) {
      this.loadCatalogV2({ url: 'commissions', page: page })
    }
  },
  methods: {
    ...mapActions([
      'loadCatalogV2',
      'updateCommission',
      'applyFilter'
    ]),
    changeInput(commission) {
      this.updateCommission({id: commission.id, commission: commission.commission_percentage}).then(() => {
        this.loadCatalogV2({ url: 'commissions', page: this.currentPage })
      })
    },
    applyFilters() {
      this.applyFilter({filters: this.filters}).then(() => {
        this.loadCatalogV2({ url: 'commissions', page: this.currentPage })
      })
    },
    handleChange (date) {
      this.filters.betweenDates.created_at = date
    },
    clearFilter () {
      this.applyFilter({filters: ''}).then(() => {
        this.loadCatalogV2({ url: 'commissions', page: 1 })
      })
    } 
  }
}
</script>
